<template>
  <div>
    <div
      v-for="(file, index) in filteredFiles"
      :key="file + index"
    >
      <a
        :href="getDownloadLink(file)"
        target="_blank"
        download
        class="downloads"
        :title="getAltText(file)"
      >
        <div class="downloads__element">
          <component
            :is="getIconComponent(file)"
            class="downloads__element--icon"
          />
          <div
            class="text downloads__element--text"
            v-text="getFileName(file)"
          />
        </div>
        <ActionFile
          :title="$tv('downloadIconTooltip', 'product')"
          class="action-file-download text"
        />
      </a>
    </div>
  </div>
</template>

<script>
import ActionFile from '~/assets/icons/action_file_present.svg?component'
import downloadService from '../assets/js/utils/download_service'
import itemImageUrlMixin from '~/mixins/item_image_url'
import ImagePictureAsPdf from '~/assets/icons/image_picture_as_pdf.svg?component'
import Image from '~/assets/icons/image_image.svg?component'
import EditorInsertDriveFile from '~/assets/icons/editor_insert_drive_file.svg?component'
import CadIcon from '~/assets/icons/download.svg?component'

export default {
  name: 'Download',
  components: {
    ActionFile
  },
  mixins: [itemImageUrlMixin],
  data() {
    return {
      type: ''
    }
  },
  methods: {
    getAltText(file) {
      return file?.altText ?? ''
    },
    getIconComponent(contentType) {
      switch (downloadService(contentType)) {
      case 'image': {
        return Image
      }
      case 'file': {
        return EditorInsertDriveFile
      }
      case 'pdf-mime-type': {
        return ImagePictureAsPdf
      }
      case 'cad': {
        return CadIcon
      }
      default: {
        return null
      }
      }
    },
    getFileName(file) {
      if (file?.label) {
        return file.label
      }
      if (file?.assetType) {
        return this.$tv(file.assetType, 'product.assetLink')
      }
      if (file?.lookupKey) {
        let splitUrl = file.lookupKey.split('/')
        splitUrl = splitUrl[splitUrl.length - 1].split('?')
        return splitUrl[0]
      }
      return ''
    },
    getDownloadLink(file) {
      if (file?.lookupKey.includes('http://') || file?.lookupKey.includes('https://')) {
        return file?.lookupKey ?? ''
      }
      return this.url + (file?.lookupKey ?? '')
    }
  },
  computed: {
    filteredFiles() {
      const filteredFiles = this.files?.filter((file, currentIndex, array) => {
        const firstIndex = array.findIndex(f => f.lookupKey === file.lookupKey)
        return currentIndex === firstIndex || !(file.sourceCMS && !array[firstIndex].sourceCMS)
      })
      return filteredFiles
    }
  },
  props: {
    files: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.downloads {
  display: flex;
  color: $color__primary;
  margin-bottom: 1em;
  text-decoration: none;
  justify-content: space-between;
  align-items: center;

  @include breakpoint-down($md) {
    box-shadow: 0 .1875rem .375rem $color--accordion__shadow;
    padding: .5em;
  }

  .icon--svg.text {
    font-size: 1.5rem;
  }

  &__element {
    display: flex;

    &--icon {
      font-size: 1.6em;

      @include breakpoint-down($md) {
        font-size: 1.6em;
      }
    }

    &--iconENext {
      width: 1.6em;
      margin-top: .5em;

      @include breakpoint-down($md) {
        width: 1.6em;
      }
    }

    &--text {
      margin-left: 1em;
      color: $color__secondary;
      justify-content: space-between;
      word-wrap: break-word;

      @include breakpoint-down($md) {
        font-weight: $base-text-font-weight-bold;
        color: $color__primary;
      }
    }
  }

  .action-file-download.text {
    color: $color__default;
    display: none;

    @include breakpoint-down($md) {
      display: block;
    }
  }
}

.tab__content__wrapper .downloads .text {
  padding: .5em;
}
</style>

<style lang="scss">
.downloads {
  .tab {
    @include breakpoint-down($md) {
      margin-bottom: 0;
      margin-left: -.375rem;
      margin-right: -.375rem;
      padding-left: .375rem;
      padding-right: .375rem;
    }
  }
}
</style>
